export type TextSize = 'small' | 'default' | 'large';

export const TEXT_SIZE_STORAGE_KEY = 'careva-text-size';

/** Rem scale factors applied via root font-size (MUI typography uses rem). */
export const TEXT_SIZE_SCALE: Record<TextSize, number> = {
  small: 0.875,
  default: 1,
  large: 1.25,
};

const TEXT_SIZE_VALUES: TextSize[] = ['small', 'default', 'large'];

export function isTextSize(value: string | null | undefined): value is TextSize {
  return value !== null && value !== undefined && TEXT_SIZE_VALUES.includes(value as TextSize);
}

export function readStoredTextSize(): TextSize {
  if (typeof window === 'undefined') {
    return 'default';
  }
  const stored = window.localStorage.getItem(TEXT_SIZE_STORAGE_KEY);
  return isTextSize(stored) ? stored : 'default';
}

export function writeStoredTextSize(size: TextSize): void {
  window.localStorage.setItem(TEXT_SIZE_STORAGE_KEY, size);
}

export function applyTextSizeToDocument(size: TextSize): void {
  const scale = TEXT_SIZE_SCALE[size];
  document.documentElement.style.setProperty('--careva-text-scale', String(scale));
  document.documentElement.setAttribute('data-text-size', size);
  document.documentElement.style.fontSize = `${16 * scale}px`;
}
